// src/components/card/CardShell.jsx
"use client";

import Link from "next/link";
import { Fragment } from "react";

export default function CardShell({
  id,
  href,
  leading,
  header,
  children,
  actions,
  menu,
  className = "",
  bodyClassName = "prose prose-sm max-w-none text-[var(--foreground)]",
  square = true,
  edgeMobile = false,
  style,
}) {
  const rootClasses = ["relative card transition", square ? "square-mobile" : "", className]
    .filter(Boolean)
    .join(" ");
  const Wrapper = edgeMobile ? "div" : Fragment;
  const wrapperProps = edgeMobile ? { className: "edge-mobile" } : {};

  return (
    <Wrapper {...wrapperProps}>
      <article
        id={id}
        className={rootClasses}
        role="article"
        style={style}
      >
      {/* Full-card background link (behind controls) */}
      {href ? (
        <Link href={href} aria-label="Open" className="absolute inset-0 z-10" />
      ) : null}

      {/* Pinned corner menu */}
      {menu ? <div className="absolute right-2 top-2 z-40">{menu}</div> : null}

      {/* Content */}
      <div className="grid grid-cols-[48px_1fr] gap-2.5 sm:gap-4">
        {/* Leading (badge/avatar) — let overlay handle clicks by default */}
        <div className="relative pointer-events-none flex h-full">
          {leading}
        </div>

        {/* Right column */}
        <div className="min-w-0">
          {/* Header — let overlay handle clicks unless children explicitly opt-in */}
          {header ? (
            <div className="min-w-0 relative pointer-events-none">
              {header}
            </div>
          ) : null}

          {/* Body — neutral by default; CardText will elevate its own interactive bits */}
          {children ? <div className={`mt-2 sm:mt-3 ${bodyClassName}`}>{children}</div> : null}

          {/* Actions — always interactive */}
          {actions ? (
            <div className="mt-3 sm:mt-4 flex items-center gap-4 sm:gap-6 text-[13px] text-[var(--muted)] relative z-20 pointer-events-auto">
              {actions}
            </div>
          ) : null}
        </div>
      </div>
      </article>
    </Wrapper>
  );
}
